import type { Messages } from "./en";

/** French copy. Kept for a future language switch; English is the default. */
export const fr: Messages = {
  appTitle: "scrubbd",
  tagline: "Aucune donnée ne quitte cette page",
  verifyHow: "Comment le vérifier",
  limitsLink: "Fonctionnement et limites",
  stepDeposit: "1. Déposer",
  stepReview: "2. Vérifier",
  stepDownload: "3. Télécharger",
  dropHint: "Glisser un fichier .log / .txt / .json",
  chooseFile: "Choisir un fichier",
  orPaste: "ou coller du texte",
  pastePlaceholder: "Coller des logs ici…",
  analyze: "Analyser",
  clear: "Effacer",
  options: "Options",
  redactInternalIds: "Masquer les identifiants internes (user_id, device_id…)",
  redactBusinessIds: "Masquer les identifiants métier (invoice_id, order_id…)",
  geoModeLabel: "Coordonnées GPS\u00a0:",
  geoMask: "Masquer",
  geoRound: "Arrondir (~1 km)",
  ipStyleLabel: "Alias IP\u00a0:",
  ipPreserveClass: "Préserver privé / public",
  ipLabel: "Étiquettes [IP-01]",
  colon: "\u00a0: ",
  summary: "Récapitulatif",
  mappings: "Valeurs détectées",
  preview: "Aperçu après traitement",
  previewTruncated: (shown: number, total: number) =>
    `Aperçu limité aux ${shown} premiers caractères sur ${total}. Le fichier téléchargé est complet.`,
  keep: "Garder",
  replace: "Remplacer",
  downloadClean: "Fichier nettoyé",
  downloadReport: "Rapport",
  controlOk: "Contrôle : aucune valeur d’origine restante",
  controlWarn: (n: number) =>
    `Contrôle : ${n} valeur${n > 1 ? "s" : ""} d’origine détectée${n > 1 ? "s" : ""} dans la sortie`,
  emptyState: "Déposez ou collez un fichier pour commencer.",
  formatLabel: "Format",
  uniqueLabel: "valeurs uniques",
  occurrenceLabel: "occurrences",
  keptHint: "conservé",
  colDecision: "Décision",
  colType: "Type",
  colOrigin: "Origine",
  colAlias: "Alias",
  noValues: "Aucune valeur à remplacer pour l’instant.",
  limitsTitle: "Comment ça marche et limites",
  limitsBack: "← Retour à l’outil",
  limitsBody: [
    "Tout le traitement s’exécute dans votre navigateur. Après le chargement de la page, aucune requête réseau n’est émise.",
    "Pour le vérifier : ouvrez l’onglet Réseau des outils de développement, puis analysez un fichier. Vous pouvez aussi utiliser la page en mode avion.",
    "L’outil pseudonymise des valeurs évidentes (adresses IP, e-mails, téléphones via champs, adresses, GPS…). Il ne garantit ni anonymat total ni conformité RGPD. Une relecture humaine reste nécessaire avant tout partage.",
    "Les alias appartiennent à des familles distinctes (personne-01, compte-01, email-01@…, [TEL-01]…) pour éviter les fausses associations. Par défaut, une IP privée reste privée et une IP publique devient une adresse de documentation (RFC 5737).",
    "Les identifiants internes et métier sont listés mais conservés par défaut.",
  ],
};
